var map = {
	"./components/articles/_articles": [
		2438,
		9,
		2438
	],
	"./components/articles/_articles.ts": [
		2438,
		9,
		2438
	],
	"./components/benefits/_benefits": [
		2258,
		9,
		2258
	],
	"./components/benefits/_benefits.ts": [
		2258,
		9,
		2258
	],
	"./components/campaign/_wheel-campaign": [
		4193,
		9,
		7083,
		4193
	],
	"./components/campaign/_wheel-campaign.vue": [
		4193,
		9,
		7083,
		4193
	],
	"./components/competition/_competition-form": [
		9464,
		9,
		9464
	],
	"./components/competition/_competition-form.ts": [
		9464,
		9,
		9464
	],
	"./components/faq/_faq": [
		3790,
		7,
		3790
	],
	"./components/faq/_faq.ts": [
		3790,
		7,
		3790
	],
	"./components/shared/kasa-notification/_notifications": [
		3442,
		9,
		3442
	],
	"./components/shared/kasa-notification/_notifications.ts": [
		3442,
		9,
		3442
	],
	"./data-layer/_homepage-analytics": [
		5476,
		9,
		5476
	],
	"./data-layer/_homepage-analytics.ts": [
		5476,
		9,
		5476
	],
	"./data-layer/_kasa-submenu-analytics": [
		7194,
		9,
		7194
	],
	"./data-layer/_kasa-submenu-analytics.ts": [
		7194,
		9,
		7194
	],
	"./homepage/_anchor-animation": [
		3298,
		9,
		917
	],
	"./homepage/_anchor-animation.ts": [
		3298,
		9,
		917
	],
	"./homepage/_homepage-header": [
		1193,
		9,
		1193
	],
	"./homepage/_homepage-header.ts": [
		1193,
		9,
		1193
	],
	"./homepage/_wheel-winners-carousel": [
		9713,
		9,
		9713
	],
	"./homepage/_wheel-winners-carousel.ts": [
		9713,
		9,
		9713
	],
	"./homepage/_winners-stories-carousel": [
		8991,
		9,
		8991
	],
	"./homepage/_winners-stories-carousel.ts": [
		8991,
		9,
		8991
	],
	"./landing-pages/_extra-game": [
		2149,
		9,
		4530
	],
	"./landing-pages/_extra-game.ts": [
		2149,
		9,
		4530
	],
	"./wheel-of-fortune/wheel-page/_wheel-page": [
		2374,
		9,
		7083,
		5566,
		4071,
		881,
		1673,
		2374
	],
	"./wheel-of-fortune/wheel-page/_wheel-page.vue": [
		2374,
		9,
		7083,
		5566,
		4071,
		881,
		1673,
		2374
	],
	"./widgets/benefit-floor/_benefit-floor-animations": [
		9263,
		9,
		7083,
		9263
	],
	"./widgets/benefit-floor/_benefit-floor-animations.ts": [
		9263,
		9,
		7083,
		9263
	],
	"./widgets/extra-game-shops-filter/_extra-game-shops-filter": [
		6151,
		9,
		6151
	],
	"./widgets/extra-game-shops-filter/_extra-game-shops-filter.vue": [
		6151,
		9,
		6151
	],
	"./widgets/hero-simple/_hero-simple": [
		8319,
		9,
		8319
	],
	"./widgets/hero-simple/_hero-simple.ts": [
		8319,
		9,
		8319
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6800;
module.exports = webpackAsyncContext;